import { Component, OnInit } from '@angular/core';
import { R3requestsService } from 'app/services/R3Services/R3.service';
import { MessageService, ConfirmationService, PrimeNGConfig, LazyLoadEvent } from 'primeng/api';
import { R3Component } from '../R3/R3.component';
import { R3Element } from 'app/models/R3.model';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { gql, Apollo } from 'apollo-angular';
import * as FileSaver from 'file-saver';
import { ReportR3Element } from 'app/models/reportR3.model';
import { SearchR3Element } from 'app/models/searchR3.model';
import { GenericElement } from 'app/models/generic.model';
import { DatePipe } from '@angular/common';
import { KeycloakService } from 'keycloak-angular';
import { R3ReportNameElement } from 'app/models/R3ReportName.model';


@Component({
  selector: 'app-dashboardR3',
  templateUrl: './dashboardR3.component.html',
  styleUrls: ['./dashboardR3.component.css'],
  providers: [DialogService, MessageService]
})

export class DashboardR3Component implements OnInit {

  R3Dialog: boolean;
  R3s: R3Element[];
  R3: R3Element;
  selectedR3s: R3Element[];
  submitted: boolean;
  loading: boolean;
  allRegisters: number;
  cols: any[];
  isView: boolean = false;
  isEdit: boolean = false;
  error: string;
  R3Id: string;
  R3sExcel: R3Element[];
  R3sReport: ReportR3Element[];
  R3sReportName: R3ReportNameElement[];
  isViewButtons: boolean = false;
  dialogSearch: boolean = false;
  isClosingAsigned: boolean = true;
  isAdmin: boolean = false;
  isSellingAgent: boolean = false;
  isListingAgent: boolean = false;
  isNotary: boolean = false;
  searchR3Element: SearchR3Element = {};
  parameters: GenericElement[];
  selectedParameter: GenericElement = {};
  typesOfBrokers: GenericElement[];
  selectedTypeBroker: GenericElement = {};
  dates: GenericElement[];
  selectedDate: GenericElement = {};
  isUser: boolean = false;
  public datepipe: DatePipe;
  lastTableLazyLoadEvent: LazyLoadEvent;
  isSearch: boolean = false;
  first: number = 0;

  constructor(
    public messageService: MessageService,
    public dialogService: DialogService,
    private R3Service: R3requestsService,
    private primengConfig: PrimeNGConfig,
    private confirmationService: ConfirmationService,
    private apollo: Apollo,
    private keycloakService: KeycloakService
  ) {
  }

  ref: DynamicDialogRef;

  ngOnInit(): void {
    this.primengConfig.ripple = true;
    this.loading = true;
    this.validarIsAdmin();
    this.loadParameters();
    this.loadTypesBroker();
    this.loadDates();
    this.ValidateCloser();
    this.validarIsListingAgent();
    this.validarIsSellingAgent();
    this.validarIsNotary();
  }

  ValidateCloser() {
    if (this.keycloakService.isUserInRole("closingUser")) {
      this.isUser = true;
    }
    else {
      this.isUser = false;
    }
  }

  validarIsAdmin() {
    if (this.keycloakService.isUserInRole("closingAdmin") || this.keycloakService.isUserInRole("closingSuperUser")) {
      this.isAdmin = true;
    }
    else {
      this.isAdmin = false;
    }
  }

  validarIsSellingAgent() {
    if (this.keycloakService.isUserInRole("closingSellingAgent")) {
      this.isSellingAgent = true;
    }
    else {
      this.isSellingAgent = false;
    }
  }

  validarIsListingAgent() {
    if (this.keycloakService.isUserInRole("closingListingAgent")) {
      this.isListingAgent = true;
    }
    else {
      this.isListingAgent = false;
    }
  }

  validarIsNotary() {
    if (this.keycloakService.isUserInRole("closingNotary")) {
      this.isNotary = true;
    }
    else {
      this.isNotary = false;
    }
  }

  loadDates() {
    this.dates = [
      { name: 'Select Status', value: '' },
      { name: 'Open Files', value: 'Open' },
      { name: 'Closed Files', value: 'Closed' },
      { name: 'Cancelled', value: 'Cancelled' },
      { name: 'All', value: 'all' }
    ]
  }
  loadParameters() {
    this.parameters = [
      { name: 'Select Filter Type', value: '' },
      { name: 'By File', value: '1' },
      { name: 'By Dates', value: '2' },
      { name: 'All', value: '3' }
    ]
  }

  loadTypesBroker() {
    this.typesOfBrokers = [
      { name: 'Select Type of Broker', value: '' },
      { name: 'Listing Agent', value: 'listing' },
      { name: 'Selling Agent', value: 'selling' }
    ]
  }

  detalleR3(R3) {
    this.isView = true;
    this.ref = this.dialogService.open(R3Component, {
      header: 'View details',
      width: '100vw',
      height: '100vh',
      baseZIndex: 10000,
      data: { r3FileNumber: R3.r3FileNumber, isView: this.isView }
    });
  }

  editR3(R3) {
    this.isView = false;
    this.isEdit = true;
    this.ref = this.dialogService.open(R3Component, {
      header: 'Edit R3',
      width: '100vw',
      height: '100vh',
      baseZIndex: 10000,
      closable: false,
      data: { r3FileNumber: R3.r3FileNumber, isView: this.isView, isEdit: this.isEdit }
    });
    this.ref.onClose.subscribe((R3: R3Component) => {
      if (R3) {
        this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'R3 Edit ' + R3.r3FileNumber, life: 4000 });
        this.recargar();
      }

    });
  }

  deleteR3(R3: R3Element) {
    this.isView = false;
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete  R3 File Number ' + R3.r3FileNumber + '?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.R3Service.deleteR3(R3).subscribe(_res => {
          this.R3s = this.R3s.filter(val => val.r3FileNumber !== R3.r3FileNumber);
          this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'R3 Deleted', life: 3000 });
          this.recargar();
        },
          err => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error.error, life: 3000 });
          });
      }
    });
  }

  public openDialog() {
    //"this.dialogRef.open(CreateR3Component);
    this.ref = this.dialogService.open(R3Component, {
      header: 'Add R3',
      width: '100vw',
      height: '100vh',
      baseZIndex: 10000,
      closable: false
    });

    this.ref.onClose.subscribe((R3: R3Element) => {

      this.cargarR3Graphql(this.lastTableLazyLoadEvent);
      if (R3) {
        this.recargar();
      }

    });
  }

  public openDialogSearch() {
    this.dialogSearch = true;
    this.searchR3Element = {};
    this.selectedDate = {};
  }

  public hideDialogSearch() {
    this.dialogSearch = false;
  }

  clear() {
    this.isSearch = false;
    this.searchR3Element = {};
    this.selectedDate = {};
    this.first = 0;
    this.lastTableLazyLoadEvent.first = 0;
    this.lastTableLazyLoadEvent.rows = 10;
    this.cargarR3Graphql(this.lastTableLazyLoadEvent);
  }
  deleteSelectedR3s() {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete the selected R3s?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        console.log(this.selectedR3s)
        for (let i = 0; i < this.selectedR3s.length; i++) {
          this.R3Service.deleteR3(this.selectedR3s[i]).subscribe();
        }
        this.R3s = this.R3s.filter(val => !this.selectedR3s.includes(val));
        this.selectedR3s = null;
        this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'R3s Deleted', life: 3000 });
      }
    });
  }

  cargarR3Graphql(event?: LazyLoadEvent) {
    this.error = "";
    this.loading = true;
    this.lastTableLazyLoadEvent = event;
    let currentPage = event.first / event.rows;
    var nameAgent = ' ';
    if (this.keycloakService.isUserInRole("closingNotary")) {
      nameAgent = `notary:"${this.keycloakService.getUsername()}"`;
    }
    else if (this.keycloakService.isUserInRole("closingSellingAgent")) {
      nameAgent = `sellingAgent:"${this.keycloakService.getUsername()}"`;
    }
    else if (this.keycloakService.isUserInRole("closingListingAgent")) {
      nameAgent = `listingAgent:"${this.keycloakService.getUsername()}"`;
    }
    this.apollo
      .query<any>({
        query: gql`
            {
              findAllR3PaginatorSearch(page: ${currentPage}, size: ${event.rows}, searchData:{
            ${nameAgent}
          }){
            totalPages
            totalElements
            last
            numberOfElements
            empty
            first
            content{
              postClosingComplete
              r3FileNumber
              status
              r3ContractDate
              typeOfProperty
              closingProcessor{
                fullName
              }
              propertyInformation{
                propertyAddress
                city
                state{
                  stateName
                  stateId
                }
                zipCode
              }
              preClosingInformation{
                programManager{
                  name
                }
              }
              financials {
                closingAgent{
                  name
                }
              }
              buyerInformation{
                name
                middleName
                lastName
              }
              closingInformation {
                scheduleClosingDate
                actualClosingDate
                closingCancelledDate
                listingAgent{
                  name
                  fullName
                  phoneNumber
                }
                sellingAgent{
                  name
                  fullName
                  phoneNumber
                }
              }
            }
          }
        }
        `
      })
      .subscribe(
        ({ data, loading }) => {
          if (data.findAllR3PaginatorSearch.empty) {
            this.messageService.add({ severity: 'info', summary: 'There are no results' });
            this.R3 = {};
            this.loading = loading;
            this.isClosingAsigned = false;
          } else {
            this.loading = loading;
            this.R3s = data.findAllR3PaginatorSearch.content;
            this.R3 = {};
            this.R3.financials = {};
            for (let i of this.R3s) {
              this.R3.r3FileNumber = i.r3FileNumber;
              this.R3.buyerInformation = i.buyerInformation;
              this.R3.propertyInformation = i.propertyInformation;
              this.R3.preClosingInformation = i.preClosingInformation;
              this.R3.closingInformation = i.closingInformation;
              this.R3.status = i.status;
              this.R3.r3ContractDate = i.r3ContractDate;
              this.R3.financials = i.financials;
              this.R3.postClosingComplete = i.postClosingComplete;
              this.R3.closingInformation = i.closingInformation;

            }
            this.allRegisters = data.findAllR3PaginatorSearch.totalElements;

          }

        }
      );
  }

  search(event?: LazyLoadEvent) {
    this.isSearch = true;
    var inputR3FileNumber = (this.searchR3Element.r3FileNumber ? `r3FileNumber: "${this.searchR3Element.r3FileNumber}",` : '');
    var inputStatus = (this.selectedDate.value ? `status: "${this.selectedDate.value}",` : ' ');
    var nameAgent = ' ';

    if (this.searchR3Element.r3ContractDateFrom) {
      var dateFrom = new Date(this.searchR3Element.r3ContractDateFrom.getTime() - this.searchR3Element.r3ContractDateFrom.getTimezoneOffset() * 60000).toISOString();
    }
    if (this.searchR3Element.r3ContractDateTo) {
      var dateTo = new Date(this.searchR3Element.r3ContractDateTo.getTime() - this.searchR3Element.r3ContractDateTo.getTimezoneOffset() * 60000).toISOString();
    }
    var inputContractDateFrom = (this.searchR3Element.r3ContractDateFrom ? `contractDateFrom:"${dateFrom}",` : ' ');
    var inputContractDateTo = (this.searchR3Element.r3ContractDateTo ? `contractDateTo:"${dateTo}",` : ' ');
    if (this.keycloakService.isUserInRole("closingNotary")) {
      nameAgent = `notary:"${this.keycloakService.getUsername()}"`;
    }
    else if (this.keycloakService.isUserInRole("closingSellingAgent")) {
      nameAgent = `sellingAgent:"${this.keycloakService.getUsername()}"`;
    }
    else if (this.keycloakService.isUserInRole("closingListingAgent")) {
      nameAgent = `listingAgent:"${this.keycloakService.getUsername()}"`;
    }
    let currentPage;
    let size;
    if (event) {
      currentPage = event.first / event.rows;
      this.first = event.first;
      size = event.rows;
    } else {
      this.first = 0;
      size = 10;
      currentPage = this.first / size;  
    }

    if (inputR3FileNumber || inputStatus || inputContractDateFrom || inputContractDateTo || nameAgent) {
      this.dialogSearch = false;
      this.apollo
        .query<any>({
          query: gql`
        {
          findAllR3PaginatorSearch(page: ${currentPage}, size: ${size}, searchData:{
            ${inputR3FileNumber}
            ${inputStatus}
            ${inputContractDateFrom}
            ${inputContractDateTo}
            ${nameAgent}
          }){
            totalPages
            totalElements
            last
            numberOfElements
            empty
            first
            content{
              postClosingComplete
              r3FileNumber
              status
              r3ContractDate
              typeOfProperty
              closingProcessor{
                fullName
              }
              propertyInformation{
                propertyAddress
                city
                state{
                  stateName
                  stateId
                }
                zipCode
              }
              preClosingInformation{
                programManager{
                  name
                }
              }
              financials {
                closingAgent{
                  name
                }
              }
              buyerInformation{
                name
                middleName
                lastName
              }
              closingInformation {
                scheduleClosingDate
                actualClosingDate
                closingCancelledDate
                listingAgent{
                  name
                  fullName
                  phoneNumber
                }
                sellingAgent{
                  name
                  fullName
                  phoneNumber
                }
              }
            }
          }
        }
        `
        })
        .subscribe(
          ({ data }) => {
            if (data.findAllR3PaginatorSearch.empty) {
              this.messageService.add({ severity: 'info', summary: 'There are no results' });
              this.R3s = [];
              this.allRegisters = 0; 
            } else {
              this.R3s = data.findAllR3PaginatorSearch.content;
              this.allRegisters = this.R3s.length;
            }
          }
        );
    }
    else {
      this.dialogSearch = true;
      this.messageService.add({ severity: 'info', summary: 'Please add a filter to search' });

    }

  }
  cleanParameters(){
    this.searchR3Element = {};
    this.selectedDate = {};
    }
  recargar() {
    this.loading = true;
    this.R3s = [];
    var nameAgent = ' ';

    if (this.keycloakService.isUserInRole("closingNotary")) {
      nameAgent = `notary:"${this.keycloakService.getUsername()}"`;
    }
    else if (this.keycloakService.isUserInRole("closingSellingAgent")) {
      nameAgent = `sellingAgent:"${this.keycloakService.getUsername()}"`;
    }
    else if (this.keycloakService.isUserInRole("closingListingAgent")) {
      nameAgent = `listingAgent:"${this.keycloakService.getUsername()}"`;
    }

    this.dialogSearch = false;
    let currentPage = this.lastTableLazyLoadEvent.first / this.lastTableLazyLoadEvent.rows;
    this.apollo
      .query<any>({
        query: gql`
        {
          findAllR3PaginatorSearch(page: ${currentPage}, size: ${this.lastTableLazyLoadEvent.rows}, searchData:{
            ${nameAgent}
          }){
            totalPages
            totalElements
            last
            numberOfElements
            empty
            first
            content{
              postClosingComplete
              r3FileNumber
              status
              r3ContractDate
              typeOfProperty
              closingProcessor{
                fullName
              }
              propertyInformation{
                propertyAddress
                city
                state{
                  stateName
                  stateId
                }
                zipCode
              }
              preClosingInformation{
                programManager{
                  name
                }
              }
              financials {
                closingAgent{
                  name
                }
              }
              buyerInformation{
                name
                middleName
                lastName
              }
              closingInformation {
                scheduleClosingDate
                actualClosingDate
                closingCancelledDate
                listingAgent{
                  name
                  fullName
                  phoneNumber
                }
                sellingAgent{
                  name
                  fullName
                  phoneNumber
                }
              }
            }
          }
        }
        `
      })
      .subscribe(
        ({ data }) => {
          this.R3s = data.findAllR3PaginatorSearch.content;
          this.R3 = {};
          if (data.findAllR3PaginatorSearch.empty) {
            this.messageService.add({ severity: 'info', summary: 'There are no results' });
          } else {
            for (let i of this.R3s) {
              this.R3.r3FileNumber = i.r3FileNumber;
              this.R3.buyerInformation = i.buyerInformation;
              this.R3.propertyInformation = i.propertyInformation;
              this.R3.preClosingInformation = i.preClosingInformation;
              this.R3.closingInformation = i.closingInformation;
              this.R3.status = i.status;
              this.R3.r3ContractDate = i.r3ContractDate;
              this.R3.financials = i.financials;
              this.R3.postClosingComplete = i.postClosingComplete;
              this.R3.closingInformation = i.closingInformation;

            }
            this.allRegisters = this.R3s.length;

          }

        }
      );
    this.loading = false;
  }




  exportExcel() {
    if (this.keycloakService.isUserInRole("closingSellingAgent") || this.keycloakService.isUserInRole("closingListingAgent") || this.keycloakService.isUserInRole("closingNotary")) {
      this.R3sExcel = this.R3s;
      this.formatReportAgents();
    } else {
      this.R3Service.getR3s().subscribe(res => {
        this.R3sExcel = [];
        if (res) {
          this.R3sExcel = res;
          this.formatReport();
        }
      })
    }
  }

  formatReportAgents() {
    this.R3sReport = [];
    let i = 0;
    this.R3sExcel.forEach(element => {
      this.R3sReport[i] = {};
      this.R3sReport[i].Deval_File_Number = (element.r3FileNumber ? element.r3FileNumber : null);
      this.R3sReport[i].Status = (element.status ? element.status : null);
      if (element.buyerInformation) {
        /**Setea la primer posicion del buyerInformation en el campo borrowerName y el resto lo pone en el campo coBorrowerName*/
        this.R3sReport[i].Borrower_Name = ((element.buyerInformation[0].name ? element.buyerInformation[0].name : '') + " " +
          (element.buyerInformation[0].middleName ? element.buyerInformation[0].middleName : '') + " " +
          (element.buyerInformation[0].lastName ? element.buyerInformation[0].lastName : '') + "\n")
        for (let j = 1; j < element.buyerInformation.length; j++) {
          this.R3sReport[i].Co_Borrower_Name = ((element.buyerInformation[j].name ? element.buyerInformation[j].name : '') + " " +
            (element.buyerInformation[j].middleName ? element.buyerInformation[j].middleName : '') + " " +
            (element.buyerInformation[j].lastName ? element.buyerInformation[j].lastName : '') + "\n")
        }
      } else {
        this.R3sReport[i].Borrower_Name = '';
        this.R3sReport[i].Co_Borrower_Name = '';
      }
      if (element.propertyInformation) {
        this.R3sReport[i].Property_Address = ((element.propertyInformation.propertyAddress ? element.propertyInformation.propertyAddress : '') + " " +
          (element.propertyInformation.city ? element.propertyInformation.city : '') + ", " +
          (element.propertyInformation.state.stateId ? element.propertyInformation.state.stateId : ' ') + " " +
          (element.propertyInformation.zipCode ? element.propertyInformation.zipCode : '') + "\n");
      } else {
        this.R3sReport[i].Property_Address = null;
      }
      this.R3sReport[i].Sale_Amount = (element.preClosingInformation.voucherAmount ? element.preClosingInformation.voucherAmount : null);
      this.datepipe = new DatePipe('en-US');
      if (element.closingInformation.closingCancelledDate) {
        /**Define el valor segun la fecha escogida de lo contratio es null*/
        this.R3sReport[i].Closing_Date = this.datepipe.transform(element.closingInformation.closingCancelledDate, 'MM/dd/yyyy');
      } else if (element.closingInformation.actualClosingDate) {
        this.R3sReport[i].Closing_Date = this.datepipe.transform(element.closingInformation.actualClosingDate, 'MM/dd/yyyy');
      } else if (element.closingInformation.scheduleClosingDate && element.closingInformation.actualClosingDate) {
        this.R3sReport[i].Closing_Date = this.datepipe.transform(element.closingInformation.actualClosingDate, 'MM/dd/yyyy');
      } else if (element.closingInformation.scheduleClosingDate && element.closingInformation.closingCancelledDate) {
        this.R3sReport[i].Closing_Date = this.datepipe.transform(element.closingInformation.closingCancelledDate, 'MM/dd/yyyy');
      } else if (element.closingInformation.scheduleClosingDate) {
        this.R3sReport[i].Closing_Date = this.datepipe.transform(element.closingInformation.scheduleClosingDate, 'MM/dd/yyyy');
      }
      else {
        this.R3sReport[i].Closing_Date = null;
      }

      if (this.keycloakService.isUserInRole("closingSellingAgent")) {
        this.R3sReport[i].SellingAgent_FullName = (element.closingInformation.sellingAgent.fullName ? element.closingInformation.sellingAgent.fullName : null);
        this.R3sReport[i].SellingAgent_PhoneNumber = (element.closingInformation.sellingAgent.phoneNumber ? element.closingInformation.sellingAgent.phoneNumber : null);

      } else if (this.keycloakService.isUserInRole("closingListingAgent")) {
        this.R3sReport[i].ListingAgent_FullName = (element.closingInformation.listingAgent.fullName ? element.closingInformation.listingAgent.fullName : null);
        this.R3sReport[i].ListingAgent_PhoneNumber = (element.closingInformation.listingAgent.phoneNumber ? element.closingInformation.listingAgent.phoneNumber : null);

      } else if (this.keycloakService.isUserInRole("closingNotary")) {
        this.R3sReport[i].SellingAgent_FullName = (element.closingInformation.sellingAgent.fullName ? element.closingInformation.sellingAgent.fullName : null);
        this.R3sReport[i].SellingAgent_PhoneNumber = (element.closingInformation.sellingAgent.phoneNumber ? element.closingInformation.sellingAgent.phoneNumber : null);
        this.R3sReport[i].ListingAgent_FullName = (element.closingInformation.listingAgent.fullName ? element.closingInformation.listingAgent.fullName : null);
        this.R3sReport[i].ListingAgent_PhoneNumber = (element.closingInformation.listingAgent.phoneNumber ? element.closingInformation.listingAgent.phoneNumber : null);

      }

      i = i + 1
    }
    );
    this.createExcel(this.R3sReport);
  }


  formatReport() {
    this.R3sReportName = [];
    let i = 0;
    this.R3sExcel.forEach(element => {
      if (element) {
        this.R3sReportName[i] = {};
        this.R3sReportName[i].Type_of_Property = (element.typeOfProperty ? element.typeOfProperty : "");
        this.R3sReportName[i].R3_File_Number = (element.r3FileNumber ? element.r3FileNumber : "");
        this.R3sReportName[i].Closing_Processor = (element.closingProcessor ? element.closingProcessor.fullName : "");
        this.R3sReportName[i].R3_Contract_Date = (element.r3ContractDate ? this.dateToString(element.r3ContractDate) : "");
        if (element.postClosingComplete) {
          var complete = (element.postClosingComplete ? "Yes" : "No");
          this.R3sReportName[i].Post_Closing_Complete = (complete ? complete : "");
        }
        if (element.propertyInformation) {
          this.R3sReportName[i].Property_Address = (element.propertyInformation.propertyAddress ? element.propertyInformation.propertyAddress : "");
          this.R3sReportName[i].Property_City = (element.propertyInformation.city ? element.propertyInformation.city : "");
          this.R3sReportName[i].Property_State = (element.propertyInformation.state ? element.propertyInformation.state.stateId : "");
          this.R3sReportName[i].Property_Zipcode = (element.propertyInformation.zipCode ? element.propertyInformation.zipCode : "");
        }
        if (element.buyerInformation) {
          var typeOfBuyer = "";
          var name = "";
          var address = "";
          var city = "";
          var stateName = "";
          var zipcode = "";
          element.buyerInformation.forEach(elementBuyer => {
            if (typeOfBuyer != "" && elementBuyer.typeOfBuyer) {
              typeOfBuyer = typeOfBuyer + ", " + elementBuyer.typeOfBuyer;
            } else if (elementBuyer.typeOfBuyer) {
              typeOfBuyer = elementBuyer.typeOfBuyer;
            }
            if (name != "") {
              name = name + ", " + elementBuyer.name + (elementBuyer.middleName ? " " + elementBuyer.middleName : "") + " " + (elementBuyer.lastName ? elementBuyer.lastName : "");
            } else {
              name = elementBuyer.name + (elementBuyer.middleName ? " " + elementBuyer.middleName : "") + " " + (elementBuyer.lastName ? elementBuyer.lastName : "");
            }
            if (address != "" && elementBuyer.address) {
              address = address + ", " + elementBuyer.address;
            } else if (elementBuyer.address) {
              address = elementBuyer.address;
            }
            if (city != "" && elementBuyer.city) {
              city = city + ", " + elementBuyer.city;
            } else if (elementBuyer.city) {
              city = elementBuyer.city;
            }
            if (stateName != "" && elementBuyer.state) {
              if (elementBuyer.state.stateId) {
                stateName = stateName + ", " + elementBuyer.state.stateId;
              }
            } else if (elementBuyer.state) {
              if (elementBuyer.state.stateId) {
                stateName = elementBuyer.state.stateId;
              }
            }
            if (zipcode != "" && elementBuyer.zipcode) {
              zipcode = zipcode + ", " + elementBuyer.zipcode;
            } else if (elementBuyer.zipcode) {
              zipcode = elementBuyer.zipcode;
            }
          });
          this.R3sReportName[i].Buyer_Type_of_Buyer = (typeOfBuyer ? typeOfBuyer : "");
          this.R3sReportName[i].Buyer_Name = (name ? name : "");
          this.R3sReportName[i].Buye_Address = (address ? address : "");
          this.R3sReportName[i].Buyer_City = (city ? city : "");
          this.R3sReportName[i].Buyer_State = (stateName ? stateName : "");
          this.R3sReportName[i].Buyer_Zipcode = (zipcode ? zipcode : "");
        }

        if (element.preClosingInformation) {
          this.R3sReportName[i].Pre_Voucher_Amount = (element.preClosingInformation.voucherAmount ? element.preClosingInformation.voucherAmount + "" : "");
          this.R3sReportName[i].Pre_Method_of_Sale = (element.preClosingInformation.methodOfSale ? element.preClosingInformation.methodOfSale : "");
          this.R3sReportName[i].Pre_Program_Manager = (element.preClosingInformation.programManager ? element.preClosingInformation.programManager.name : "");
        }
        if (element.closingInformation) {
          this.R3sReportName[i].Closing_Received_Package_Date = (element.closingInformation.receivedPackageDate ? this.dateToString(element.closingInformation.receivedPackageDate) : "");
          this.R3sReportName[i].Closing_Listing_Agent = (element.closingInformation.listingAgent ? element.closingInformation.listingAgent.fullName + "" : "");
          this.R3sReportName[i].Closing_Selling_Agent = (element.closingInformation.sellingAgent ? element.closingInformation.sellingAgent.fullName + "" : "");
          this.R3sReportName[i].Closing_Scheduled_Closing_Date = (element.closingInformation.scheduleClosingDate ? this.dateToString(element.closingInformation.scheduleClosingDate) : "");
          this.R3sReportName[i].Closing_Actual_Closing_Date = (element.closingInformation.actualClosingDate ? this.dateToString(element.closingInformation.actualClosingDate) : "");
          this.R3sReportName[i].Closing_Cancelled_Date = (element.closingInformation.closingCancelledDate ? this.dateToString(element.closingInformation.closingCancelledDate) : "");

          if (element.closingInformation.closingInformationExtentionInformationDTO) {
            var extension = "";

            element.closingInformation.closingInformationExtentionInformationDTO.forEach(elementExtension => {
              if (extension != "") {
                extension = extension +
                  ", " + "( " + (this.dateToString(elementExtension.extentionClosingDate) + " - " + elementExtension.comment + " - " + (elementExtension.waive ? "Waived" : "No Waived") + ")");
              } else {
                extension = "(" + (this.dateToString(elementExtension.extentionClosingDate) + " - " + elementExtension.comment + " - " + (elementExtension.waive ? "Waived" : "No Waived")) + ")";
              }

            });
            this.R3sReportName[i].Closing_Extension = (extension ? extension : "");
          }
        }

        if (element.postClosingInformation) {
          var typeDeed = "";
          var deedDate = "";
          var deedNumber = "";
          var notaryName = "";
          var notaryId = "";
          var notaryCost = "";
          var notaryInvoiceNumber = "";
          var recordingDate = "";
          element.postClosingInformation.forEach(elementPost => {

            if (typeDeed != "" && elementPost.typeDeed) {
              typeDeed = typeDeed + ", " + elementPost.typeDeed;
            } else if (elementPost.typeDeed) {
              typeDeed = elementPost.typeDeed;

            }
            if (deedDate != "" && elementPost.deedDate) {
              deedDate = deedDate + ", " + this.dateToString(elementPost.deedDate);
            } else if (elementPost.deedDate) {
              deedDate = this.dateToString(elementPost.deedDate);;
            }
            if (deedNumber != "" && elementPost.deedNumber) {
              deedNumber = deedNumber + ", " + elementPost.deedNumber;
            } else if (elementPost.deedNumber) {
              deedNumber = elementPost.deedNumber + "";
            }

            if (notaryName != "" && elementPost.notaryId) {
              if (elementPost.notaryId.fullName) {
                notaryName = notaryName + ", " + elementPost.notaryId.fullName;
              }
            } else if (elementPost.notaryId) {
              if (elementPost.notaryId.fullName) {
                notaryName = elementPost.notaryId.fullName;
              }

            }
            if (notaryId != "" && elementPost.notaryId) {
              if (elementPost.notaryId.notaryId) {
                notaryId = notaryId + ", " + elementPost.notaryId.notaryId;
              }
            } else if (elementPost.notaryId) {
              if (elementPost.notaryId.notaryId) {
                notaryId = elementPost.notaryId.notaryId + "";
              }
            }
            if (notaryCost != "" && elementPost.notaryCost) {
              notaryCost = notaryCost + ", " + elementPost.notaryCost;
            } else if (elementPost.notaryCost) {
              notaryCost = elementPost.notaryCost + "";
            }
            if (notaryInvoiceNumber != "" && elementPost.notaryInvoiceNumber) {
              notaryInvoiceNumber = notaryInvoiceNumber + ", " + elementPost.notaryInvoiceNumber;
            } else if (elementPost.notaryInvoiceNumber) {
              notaryInvoiceNumber = elementPost.notaryInvoiceNumber;
            }
            if (recordingDate != "" && elementPost.recordingDate) {
              recordingDate = recordingDate + ", " + this.dateToString(elementPost.recordingDate);
            } else if (elementPost.recordingDate) {
              recordingDate = this.dateToString(elementPost.recordingDate);;
            }

          });
          this.R3sReportName[i].Post_Notary_Name = (notaryName ? notaryName : null);
          this.R3sReportName[i].Post_Recording_Date = (recordingDate ? recordingDate : null);
          this.R3sReportName[i].Post_Deed_Number = (deedNumber ? deedNumber : null);
          this.R3sReportName[i].Post_Deed_Date = (deedDate ? deedDate : null);
          this.R3sReportName[i].Post_Notary_Cost = (notaryCost ? notaryCost : null);
          this.R3sReportName[i].Post_Notary_ID = (notaryId ? notaryId : null);
          this.R3sReportName[i].Post_Noytary_Invoice = (notaryInvoiceNumber ? notaryInvoiceNumber : null);
          this.R3sReportName[i].Post_Type_Deed = (typeDeed ? typeDeed : null);

        }

        if (element.financials) {
          if (element.financials.closingAgent) {
            this.R3sReportName[i].Closing_Agent_Fee = (element.financials.closingAgent.fee ? element.financials.closingAgent.fee + "" : "");
            this.R3sReportName[i].Closing_Agent_Tax_Amount = (element.financials.closingAgent.taxAmount ? element.financials.closingAgent.taxAmount + "" : "");
            this.R3sReportName[i].Closing_Agent_Total_Closing_Fee = (element.financials.closingAgent.totalClosingFee ? element.financials.closingAgent.totalClosingFee + "" : "");
          }
        }
        i = i + 1
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Not found registers', life: 3000 });
      }
    }
    );
    this.createExcel(this.R3sReportName);

  }
  dateToString(date: Date) {
    if (date) {
      this.datepipe = new DatePipe('en-US');
      var dateNew = this.datepipe.transform(date, 'MM/dd/YYYY');
      return "" + dateNew;
    } else {
      return "";
    }

  }

  createExcel(objeto: any) {
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(objeto);
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "R3s");
    });

  }


  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  viewButtons() {
    if (this.isViewButtons) {
      this.isViewButtons = false;
    } else {
      this.isViewButtons = true;
    }
  }

  loadR3s() {
    this.R3Service.getR3s().subscribe(res => {
      this.R3 = {};
      if (res) {
        this.R3s = res;
        this.R3 = {};
        for (let i of this.R3s) {
          this.R3.r3FileNumber = i.r3FileNumber;
          this.R3.buyerInformation = i.buyerInformation;
          this.R3.propertyInformation = i.propertyInformation;
          this.R3.preClosingInformation = i.preClosingInformation;
          this.R3.closingInformation = i.closingInformation;
        }
        this.allRegisters = this.R3s.length;
      }
    })
  }
  onLazyLoad(event: LazyLoadEvent) {
    if (this.isSearch) {
      this.search(event);
    } else {
      this.cargarR3Graphql(event);
    }
  }
}
